<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Adicionar Cronograma Físico
        </b-button>
        <cronograma-fisico-form
            operacaoProp="I"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></cronograma-fisico-form>
    </div>
</template>

<script>
import CronogramaFisicoForm from './CronogramaFisicoForm'

export default {
    components: {
        CronogramaFisicoForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(cronograma){
            this.$store.dispatch('addRequest')
            let cronogramaFisicoDto = {
                pleitoId : cronograma.pleitoId,
                acaoId: cronograma.acaoId,
                meses: cronograma.meses,
                ano: cronograma.ano,
            }
            this.dataServicos.inserirCronogramaFisico(cronogramaFisicoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Cronograma inserido com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
